namespace Gamification.Gamification {
    export interface AssetEsperienzeRisorseForm {
        UserId: Serenity.IntegerEditor;
        TenantId: Serenity.IntegerEditor;
        IdAssetEsperienza: Serenity.LookupEditor;
        IdRisorsa: Serenity.LookupEditor;
    }

    export class AssetEsperienzeRisorseForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.AssetEsperienzeRisorse';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AssetEsperienzeRisorseForm.init)  {
                AssetEsperienzeRisorseForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(AssetEsperienzeRisorseForm, [
                    'UserId', w0,
                    'TenantId', w0,
                    'IdAssetEsperienza', w1,
                    'IdRisorsa', w1
                ]);
            }
        }
    }
}
